import { z } from 'zod';
import { ProcessConnectionSchema } from '../../entities/process-connection/process-connection.schema';
import { ObjectIdSchema } from '../../shared/object-id.schema';
/**
 * Create Process Connection Request Schema
 * POST /api/v2/process/connections
 */ export const CreateProcessConnectionRequestSchema = z.object({
    sourceProcessId: ObjectIdSchema,
    sourceStepId: ObjectIdSchema,
    sourceRuleId: ObjectIdSchema.optional(),
    targetProcessId: ObjectIdSchema,
    targetInputKey: z.string().min(1)
});
/**
 * Create Process Connection Response Schema
 */ export const CreateProcessConnectionResponseSchema = z.object({
    connection: ProcessConnectionSchema
});

//# sourceMappingURL=create-process-connection.schema.js.map